var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('div',{staticClass:"text-center my-6"},[_c('v-progress-circular',{attrs:{"indeterminate":""}})],1):_c('div',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }